module.exports = __webpack_public_path__ + "img/analysis-results-update-mobile-ru.32bcf81d.jpg";